import * as React from 'react'
import { CSSProperties, ReactElement } from 'react'
import { history } from '../../../../../../../../store'

import { colors } from '@lmc/common/constants'
import { Modal } from '@lmc/ui-kit'

type SignLaterModalProps = {
  handleCloseModals: () => void
  setShowSignLaterModal: (show: boolean) => void
  showSignLaterModal: boolean
  translate: (key: string, variable?: any) => string
}

export const SignLaterModal = ({
  handleCloseModals,
  translate,
  setShowSignLaterModal,
  showSignLaterModal,
}: SignLaterModalProps): ReactElement => (
  <Modal
    setIsModalVisible={setShowSignLaterModal}
    isModalVisible={showSignLaterModal}
  >
    <div style={styles.signLaterModal as CSSProperties}>
      <div style={styles.laterTitle}>{translate('finishForm')}</div>
      <div style={styles.laterSubTitle}>{translate('theForm')}</div>
      <div style={styles.linkButton} onClick={() => history.push(`/`)}>
        {translate('backHome')}
      </div>
      <div>or</div>
      <div style={styles.linkButton} onClick={handleCloseModals}>
        {translate('formsLocation')}
      </div>
    </div>
  </Modal>
)

const styles = {
  signLaterModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 100,
    marginBottom: 80,
  },
  linkButton: {
    color: colors.pink,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  laterTitle: {
    fontWeight: 400,
    color: colors.grey,
    fontSize: 18,
  },
  laterSubTitle: {
    fontWeight: 400,
    fontSize: 14,
    marginBottom: 10,
    marginTop: 10,
  },
}

export default SignLaterModal
